<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer" />
            <v-toolbar-title>{{ `${$route.meta.title}` | t }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                dark
                color="bal-red"
                class="px-2 ml-2"
                style="min-width: 0;"
                v-if="
                    $route.name === 'ext-product-price-list' &&
                        hasPermissionForAction(PermissionsConstants.PRICE_MONITORING, PermissionsConstants.CREATE)
                "
                @click.stop="handleAddNewExtProductPriceClick"
            >
                <v-icon>add</v-icon>
            </v-btn>
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen" />

        <!-- Main content -->
        <v-main>
            <router-view />
        </v-main>

        <v-navigation-drawer :value="drawerOpen" fixed right hide-overlay width="800">
            <ext-product-price-view
                v-if="$route.name === 'ext-product-price-view' || $route.name === 'ext-product-price-edit'"
            />
        </v-navigation-drawer>

        <v-snackbar color="success" bottom :timeout="2500" :value="requestSuccess">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ "Success" | t }}</div>
            </div>
        </v-snackbar>

        <!-- Error snackbar -->
        <v-snackbar color="error" bottom :timeout="2500" :value="requestError">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">error</v-icon>
                <div class="title pa-2 ">Error</div>
            </div>
        </v-snackbar>
        <!-- Footer -->
        <page-footer />
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";
import ExtProductPriceList from "@/pages/ext-product-price/ext-product-price-list.vue";
import ExtProductPriceView from "@/pages/ext-product-price/ext-product-price-view.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { PermissionsConstants } from "@/permissions";
import settings from "@/settings";

export default {
    components: {
        PageFooter,
        MainDrawer,
        ExtProductPriceList,
        ExtProductPriceView
    },
    data() {
        return {
            mainDrawerOpen: null,
            fileUploadValue: null
        };
    },
    async mounted() {
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }

        if (this.$route.params.extProductPriceId && this.$route.params.extProductPriceId !== "new") {
            const param = {
                id: this.$route.params.extProductPriceId
            };
            await Store.dispatch("ExtProductStore/getProductPriceData", param);
        }
    },
    destroyed() {},
    computed: {
        PermissionsConstants() {
            return PermissionsConstants;
        },
        ...mapGetters(["hasPermissionForAction"]),
        ...mapState(["user"]),
        ...mapState("ExtProductStore", ["drawerOpen", "requestSuccess", "requestError"])
    },
    methods: {
        ...mapActions("ExtProductStore", ["getProductPriceData"]),
        ...mapMutations("ExtProductStore", ["addNewExtProductPrice"]),
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
        async handleAddNewExtProductPriceClick() {
            await this.addNewExtProductPrice();
            await this.$router.push({ name: "ext-product-price-edit", params: { extProductPriceId: "new" } });
        }
    }
};
</script>

<style scoped></style>
